/* eslint-disable react/prop-types */
/* eslint-disable no-nested-ternary */
import React from "react";
import styled, { css } from "styled-components";

const customStyles = css`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  padding: 10px 15px;
  gap: 10px;
  height: 35px;
  border-radius: 4px;
  font-weight: 500;
  font-size: 12px;
  cursor: pointer;
`;
const CustomButton = styled.button`
  ${customStyles}
  background: ${(props) =>
    props.cancel
      ? "var(--foundation-gray-01, #FFF)"
      : props.disabled
      ? "grey"
      : "#00ADF8"};
  color: ${(props) => (props.cancel ? "#0070D2" : "#FFF")};
  border: ${(props) =>
    props.cancel
      ? "1px solid var(--foundation-blue-science-blue, #0070D2)"
      : "none"};
  width: ${(props) => (props.width ? props.width : "auto")};
`;

function Button(props) {
  return (
    <CustomButton
      cancel={props.cancel}
      disabled={props.disabled}
      width={props.width}
      onClick={props.onClick}
    >
      {props.children}
    </CustomButton>
  );
}

export default Button;
